import classNames from 'classnames';
import React from 'react';

import { LoginPageSidebar } from '@/components/organisms/LoginPageSidebar';

type Props = {
  children?: React.ReactNode | React.ReactNode[];
  isLinkSent?: boolean;
};

export const LoginLayout: React.FC<Props> = ({ children, isLinkSent }: Props) => {
  return (
    <div className={classNames(isLinkSent && 'justify-center', 'flex h-full min-h-screen w-full items-center')}>
      <div className="flex flex-col h-full md:max-w-2xl w-full m-auto justify-center items-center">{children}</div>
      {!isLinkSent && <LoginPageSidebar />}
    </div>
  );
};
